import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class GlLocalAcctDescService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Accept filterParams and rowData parameters
  saveLocalDesc(
    baseUrl: string,
    returnObj: any,
    localAcountDescDetails: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {},
    customParams?: any
  ): Observable<any> {
    
    // 🚀 CRITICAL: Use correct URL construction (baseUrl contains /gtw/)
    const url = `${baseUrl}/saveJsonObject?action_code=hhba22`;

    // 🚀 CRITICAL: Use custom params if provided, otherwise build from globalService and filterParams
    let params: any;
    if (customParams) {
      // Use the custom params structure provided by the component
      params = customParams;
    } else {
      // Fallback to old method for backward compatibility
      const globalParams = globalService || {};
      
      // Build JSON objects exactly like AngularJS service
      const jsonObj = JSON.stringify(localAcountDescDetails || []);
      const jsonSettings = JSON.stringify(returnObj || {});
      
      // Build params with all required fields matching the specified format
      params = {
        // jsonSettings and jsonObj
        jsonSettings: jsonSettings,
        jsonObj: jsonObj,
        
        // Standard params
        tax_year: rowData?.TAX_YEAR || filterParams?.tax_year || globalParams?.tax_year || '',
        screen_key: filterParams?.screen_key || globalParams?.screen_key || rowData?.SCREEN_KEY || '155',
        scenario: filterParams?.scenario || globalParams?.scenario || rowData?.SCENARIO || '74',
        jcd_key: filterParams?.jcd_key || globalParams?.jcd_key || rowData?.JCD_KEY || '250',
        jcd_ta_key: filterParams?.jcd_ta_key || globalParams?.jcd_ta_key || rowData?.JCD_TA_KEY || '1113',
        activity_key: filterParams?.activity_key || globalParams?.activity_key || rowData?.ACTIVITY_KEY || '384',
        screen_type: filterParams?.screen_type || globalParams?.screen_type || rowData?.SCREEN_TYPE || 'grid',
        is_locked: filterParams?.is_locked || globalParams?.is_locked || rowData?.IS_LOCKED || 'N',
        issue_id: filterParams?.issue_id || globalParams?.issue_id || rowData?.ISSUE_ID || '',
        issue_short_desc: filterParams?.issue_short_desc || globalParams?.issue_short_desc || rowData?.ISSUE_SHORT_DESC || '',
        issue_id_for_tx_save: filterParams?.issue_id_for_tx_save || globalParams?.issue_id_for_tx_save || rowData?.ISSUE_ID_FOR_TX_SAVE || '',
        scenarioCode: filterParams?.scenarioCode || globalParams?.scenarioCode || rowData?.SCENARIO_CODE || 'RAF',
        is_issue_key_enabled: filterParams?.is_issue_key_enabled || globalParams?.is_issue_key_enabled || rowData?.IS_ISSUE_KEY_ENABLED || 'N',
        checkLockedbj: JSON.stringify([{ scenario_key: filterParams?.scenario || globalParams?.scenario || rowData?.SCENARIO || '74' }]),
        entity_type: filterParams?.entity_type || globalParams?.entity_type || rowData?.ENTITY_TYPE || 'REG',
        chart_filter: rowData?.LOCAL_CHART_KEY || filterParams?.chart_filter || globalParams?.chart_filter || '',
        process_name: 'LOCAL_DESC_SAVE'
      };
    }

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

